import { RouteFactory } from "@app/routePaths";
import { NewsletterArchiveKeywordsEnums } from "@app/types/enums";
import { NewsletterArchiveContext } from "@app/types/Page";
import GAData from "@components/GAData/GAData";
import MetaTags from "@components/MetaTags/MetaTags";
import ThriveFooter from "@pages/Thrive/components/ThriveFooter";
import ThriveGetSocial from "@pages/Thrive/components/ThriveGetSocial";
import ThriveHeader from "@pages/Thrive/components/ThriveHeader";
import ThriveMiniAboutUs from "@pages/Thrive/components/ThriveMiniAboutUs";

import ThrivePastIssueArticles from "./ThrivePastIssueArticles";
import ThriveWantMore from "./ThriveWantMore";

export type ThriveArchiveContentProps = Pick<NewsletterArchiveContext, "data">;

export default function ThrivePastIssuesContent({
  data: { title, overview },
}: ThriveArchiveContentProps): React.ReactElement {
  return (
    <div
      className="w-full overflow-hidden bg-verticals-thrive"
      data-testid="thrive-past-issues-content-component"
    >
      <MetaTags
        title={title}
        description="Read more at The Business Times."
        slug={RouteFactory.thrivePastIssues}
      />

      <GAData title="Thrive_Past_Issues" level2="thrive" />

      <ThriveHeader />

      <div className="mx-6 flex justify-center md:mx-0">
        <ThrivePastIssueArticles
          newsletterKeyword={NewsletterArchiveKeywordsEnums.Thrive}
          articles={overview}
        />
      </div>

      <ThriveWantMore
        subscriptionTitle="Want more?"
        subscriptionDescription="Get the good stuff on work and money, every Friday."
      />

      <ThriveGetSocial />

      <ThriveMiniAboutUs />

      <div className="flex justify-center bg-gray-850 font-poppins">
        <ThriveFooter />
      </div>
    </div>
  );
}
